(function () {
  if (window.__saucyBoxIncentive) return;
  window.__saucyBoxIncentive = true;

  /* ------------------------------------------------------------------
   * Box incentive bar — live progress for the Easify Box Builder page.
   *
   * The bar's initial state is rendered server-side from the Shopify cart.
   * Items added in the Easify box builder live in the app's own footer
   * summary (the sticky tray) and are NOT in the Shopify cart until the
   * customer hits "Add to cart" — which is why the bar never moved.
   *
   * This script watches the page, reads the box's live running total from
   * the summary tray, and re-renders the bar (fill, message, milestones)
   * on every add/remove. It fails safe: if it can't read a total it leaves
   * the bar at its server value rather than ever showing a wrong number.
   *
   * OVERRIDE: if the bar ever shows the wrong figure, pin the exact Total
   * element. Open the box page → DevTools → right-click the Total amount in
   * the box footer → Inspect → Copy → Copy selector, and paste it below.
   * ------------------------------------------------------------------ */
  var CFG = { totalSelector: '', settleMs: 150 };

  var CUR = /[$£€]|\bAUD\b|\bUSD\b/i;
  var SKIP = /sav|discount|\boff\b|ship|deliver|coupon|promo|reward/i;

  var root = document.querySelector('[data-box-incentive]');
  if (!root) return;

  var FREE = parseInt(root.getAttribute('data-threshold-free'), 10);
  var TEN = parseInt(root.getAttribute('data-threshold-ten'), 10);
  var TWENTY = parseInt(root.getAttribute('data-threshold-twenty'), 10);
  var fillEl = root.querySelector('.box-incentive-banner__fill');
  var titleEl = root.querySelector('.box-incentive-banner__title');
  var ms = {
    free: root.querySelector('[data-ms="free"]'),
    ten: root.querySelector('[data-ms="ten"]'),
    twenty: root.querySelector('[data-ms="twenty"]')
  };

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }
  function setActive(el, on) { if (el) el.classList.toggle('is-active', !!on); }

  function render(cents) {
    var pct = Math.max(0, Math.min(100, (cents / TWENTY) * 100));
    if (fillEl) fillEl.style.width = pct + '%';
    if (titleEl) {
      var msg;
      if (cents <= 0) msg = 'Build your box and unlock free shipping plus bigger discounts.';
      else if (cents < FREE) msg = 'Spend ' + money(FREE - cents) + ' more to unlock free shipping.';
      else if (cents < TEN) msg = 'Spend ' + money(TEN - cents) + ' more to unlock 10% off.';
      else if (cents < TWENTY) msg = 'Spend ' + money(TWENTY - cents) + ' more to unlock 20% off.';
      else msg = "You've unlocked free shipping and the biggest discount.";
      titleEl.textContent = msg;
    }
    setActive(ms.free, cents >= FREE);
    setActive(ms.ten, cents >= TEN);
    setActive(ms.twenty, cents >= TWENTY);
  }

  /* Walk light DOM + any open shadow roots inside a scope. */
  function eachEl(scope, cb) {
    var list = scope.querySelectorAll ? scope.querySelectorAll('*') : [];
    for (var i = 0; i < list.length; i++) {
      cb(list[i]);
      if (list[i].shadowRoot) eachEl(list[i].shadowRoot, cb);
    }
  }

  /* Last currency-looking amount in a short text node → cents. */
  function nodePriceCents(text) {
    if (!text || !CUR.test(text)) return null;
    var re = /(?:[$£€]|AUD|USD)?\s?(\d[\d,]*(?:\.\d{1,2})?)/gi, m, last = null;
    while ((m = re.exec(text))) { if (m[1]) last = m[1]; }
    if (last == null) return null;
    var c = Math.round(parseFloat(last.replace(/,/g, '')) * 100);
    return isNaN(c) ? null : c;
  }
  /* Looser parse, used only for a manually pinned selector. */
  function looseCents(text) {
    if (!text) return null;
    var m = String(text).match(/(\d[\d,]*(?:\.\d{1,2})?)/);
    if (!m) return null;
    var c = Math.round(parseFloat(m[1].replace(/,/g, '')) * 100);
    return isNaN(c) ? null : c;
  }

  function collectPrices(scope) {
    var out = [];
    eachEl(scope, function (el) {
      if (el.children && el.children.length > 3) return;
      if (el.closest && el.closest('[data-box-incentive]')) return;
      var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!t || t.length > 60 || !CUR.test(t) || SKIP.test(t)) return;
      var c = nodePriceCents(t);
      if (c == null || c <= 0) return;
      out.push({ cents: c, text: t });
    });
    return out;
  }

  function pickTotal(prices, allowSum) {
    if (!prices.length) return null;
    var vals = prices.map(function (p) { return p.cents; });
    var sum = vals.reduce(function (a, b) { return a + b; }, 0);
    /* A) one amount equals the sum of the others (box total shown + item lines) */
    if (prices.length >= 2) {
      for (var i = 0; i < prices.length; i++) {
        if (Math.abs(prices[i].cents - (sum - prices[i].cents)) <= 2) return prices[i].cents;
      }
    }
    /* B) a line that literally says "total" */
    for (var j = prices.length - 1; j >= 0; j--) {
      if (/total/i.test(prices[j].text)) return prices[j].cents;
    }
    /* C) only inside the isolated tray: no total shown, so sum the item lines */
    if (allowSum) return sum;
    return null;
  }

  function currencyCount(el) {
    return ((el.textContent || '').match(/[$£€]/g) || []).length;
  }

  function pickEasify() {
    var nodes = document.querySelectorAll(
      '[class*="easify" i],[id*="easify" i],[data-easify],[data-easify-box],' +
      '[class*="box-builder" i],[class*="bundle" i],[class*="byob" i],[class*="epo" i]'
    );
    var best = null, bestCount = -1;
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.closest('[data-box-incentive]')) continue;
      var count = currencyCount(el);
      if (count > bestCount) { bestCount = count; best = el; }
    }
    return best;
  }

  /* The box total lives in the summary tray — a sticky/fixed bar pinned to
   * the viewport. Among sticky/fixed containers that show money, pick the one
   * with the most currency amounts (that's the tray, not a sticky header). */
  function stickyScope() {
    var els = document.querySelectorAll('div,section,aside,form,footer'), cands = [];
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.closest('[data-box-incentive]')) continue;
      if (!CUR.test(el.textContent || '')) continue;
      var pos = '';
      try { pos = getComputedStyle(el).position; } catch (e) {}
      if (pos !== 'fixed' && pos !== 'sticky') continue;
      cands.push({ el: el, count: currencyCount(el), size: (el.textContent || '').length });
    }
    cands.sort(function (a, b) { return b.count - a.count || a.size - b.size; });
    return cands.length ? cands[0].el : null;
  }

  function detectCents() {
    if (CFG.totalSelector) {
      var p = document.querySelector(CFG.totalSelector);
      if (p) {
        var pc = nodePriceCents(p.textContent);
        if (pc == null) pc = looseCents(p.textContent);
        if (pc != null) return pc;
      }
    }
    var tray = stickyScope();
    if (tray) {
      var t0 = pickTotal(collectPrices(tray), true);
      if (t0 != null && t0 > 0) return t0;
    }
    var wide = [];
    var s2 = pickEasify(); if (s2) wide.push(s2);
    wide.push(document.body);
    for (var i = 0; i < wide.length; i++) {
      var t = pickTotal(collectPrices(wide[i]), false);
      if (t != null && t > 0) return t;
    }
    return null;
  }

  var timer = null, warned = false, lastCents = null;
  function update() {
    if (timer) return;
    timer = setTimeout(function () {
      timer = null;
      var cents = detectCents();
      if (cents == null) {
        if (!warned) {
          warned = true;
          console.warn('[box-incentive] Box total not detected yet — bar left at its server value. ' +
            'If it never moves, pin CFG.totalSelector in assets/box-incentive-banner.js.');
        }
        return;
      }
      if (cents === lastCents) return; /* no change → no DOM writes (prevents loops) */
      lastCents = cents;
      render(cents);
    }, CFG.settleMs);
  }

  function boot() {
    var mo = new MutationObserver(update);
    mo.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true });
    document.addEventListener('input', update, true);
    document.addEventListener('change', update, true);
    document.addEventListener('click', update, true);
    update();
    /* Easify loads async — nudge a few times in case no mutation fires. */
    setTimeout(update, 800);
    setTimeout(update, 2000);
    setTimeout(update, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
